import React, { useState } from "react";
import {
  Box,
  ColumnLayout,
  Container,
  Flashbar,
  SpaceBetween,
  StatusIndicator,
} from "@cloudscape-design/components";

import { useParams } from "react-router-dom";
import DetailOverview from "./DetailOverview";



interface FlashbarItem {
  type: "info" | "warning" | "error" | "success"; // Adjust according to your requirements
  dismissible: boolean;
  dismissLabel: string;
  onDismiss: () => void;
  content: React.ReactNode;
  id: string;
}

const SummaryDetail: React.FC = () => {
  let { SerialNumber } = useParams();
  const [items, setItems] = useState<FlashbarItem[]>([
    {
      type: "info",
      dismissible: true,
      dismissLabel: "Dismiss message",
      onDismiss: () => setItems([]),
      content: <>Last Updated data changed at 03/10/2023 15:30:21</>,
      id: "message_1",
    },
  ]);

  return (
    <Container>
    <ColumnLayout columns={2} minColumnWidth={500}>
      <div>
        <div>
        <h1>Detail Tyre</h1>
        <h3>S/N : {SerialNumber}</h3>
        </div>
        <div  style={{ marginBottom: 20 }}>
        <Flashbar items={items} />
        </div>
        <ColumnLayout borders='horizontal' columns={2}>
          <div>Tyre ID</div>
          <div style={{ fontWeight: 'bold' }}>2</div>
          <div>Sensor ID</div>
          <div style={{ fontWeight: 'bold' }}>98765001</div>
          <div>Brand</div>
          <div>Bridgestone</div>
          <div>Type Tyre</div>
          <div>ABC</div>
          <div>Vehicle Code</div>
          <div>CO120</div>
          <div>Tyre Status</div>
          <div><StatusIndicator type="success">Plug</StatusIndicator></div>
          <div>Current Alarm</div>
          <div><StatusIndicator type="warning">(1) Under Pressure</StatusIndicator></div>
          
          
          
        </ColumnLayout>
      </div>

      <DetailOverview />
    </ColumnLayout>
    </Container>
  );
};

export default SummaryDetail;
